// eslint-disable-next-line
export const COLORS = [
  '#1B2049',
  '#404395',
  '#3866C8',
  '#0388C8',
  '#0BABB8',
  '#74d0d1',
];
